export default {
  pageSize: {
    id: 'bo_sellers-buyback-opportunities-table-page-size',
    defaultMessage: 'Page size',
  },
  productTitle: {
    id: 'bo_sellers-buyback-opportunities-table-product-title',
    defaultMessage: 'Product title',
  },
  grade: {
    id: 'bo_sellers-buyback-opportunities-table-grade',
    defaultMessage: 'Grade',
  },
  marketCode: {
    id: 'bo_sellers-buyback-opportunities-table-market-code',
    defaultMessage: 'Market code',
  },
  priceToWinBackboxEstimation: {
    id: 'bo_sellers-buyback-opportunities-table-price-to-win-backbox-estimation',
    defaultMessage: 'Price to win backbox estimation',
  },
  margin: {
    id: 'bo_sellers-buyback-opportunities-table-margin',
    defaultMessage: 'Margin',
  },
  profitPotentialRank: {
    id: 'bo_sellers-buyback-opportunities-table-profit-potential-rank',
    defaultMessage: 'Profit potential rank',
  },
  loading: {
    id: 'bo_sellers-buyback-opportunities-table-loading',
    defaultMessage: 'Loading opportunities...',
  },
  numberOfOpportunities: {
    id: 'bo_sellers-buyback-opportunities-table-number-of-opportunities',
    defaultMessage: '{numberOfOpportunities} sourcing opportunities',
  },
  lastUpdatedAt: {
    id: 'bo_sellers-buyback-opportunities-table-last-updated-at',
    defaultMessage: 'All data are updated at {lastUpdatedAt}',
  },
  description: {
    id: 'bo_sellers-buyback-opportunities-table-description',
    defaultMessage:
      "We show you the devices on Back Market that yield the most profit and that you're currently missing out on by not sourcing them from Trade-in. You set filters for the markets, categories, and grades you want, see your margin potential instantly, and choose whether to create listings. ",
  },
  createListing: {
    id: 'bo_sellers-buyback-opportunities-table-create-listing',
    defaultMessage: 'Create listing',
  },
  turnOnline: {
    id: 'bo_sellers-buyback-opportunities-table-turn-online',
    defaultMessage: 'Turn online',
  },
  updatePrice: {
    id: 'bo_sellers-buyback-opportunities-table-update-price',
    defaultMessage: 'Update price',
  },
  competitionLevel: {
    id: 'bo_sellers-buyback-opportunities-table-competition-level',
    defaultMessage: 'Competition level',
  },
  ordersVolume: {
    id: 'bo_sellers-buyback-opportunities-table-orders-volume',
    defaultMessage: 'Orders volume',
  },
  averageSellingPrice: {
    id: 'bo_sellers-buyback-opportunities-table-average-selling-price',
    defaultMessage: 'Average selling price',
  },
  high: {
    id: 'bo_sellers-buyback-opportunities-table-high',
    defaultMessage: 'High',
  },
  medium: {
    id: 'bo_sellers-buyback-opportunities-table-medium',
    defaultMessage: 'Medium',
  },
  low: {
    id: 'bo_sellers-buyback-opportunities-table-low',
    defaultMessage: 'Low',
  },
  veryLow: {
    id: 'bo_sellers-buyback-opportunities-table-very-low',
    defaultMessage: 'Very low',
  },
}
